import { gql } from '@apollo/client'

export const INJURY_MASTER_SETTINGS_UPDATE_MUTATION = gql`
  mutation INJURY_MASTER_SETTINGS_UPDATE_MUTATION($input: InjuryMasterSettingsUpdateInput!) {
    injuryMasterSettingsUpdate(input: $input) {
      ok
      message
    }
  }
`

// Deletes the saved connection and ends an active sync run; nothing is deleted in Injury Master.
// clearLinks: false keeps the records' Injury Master ids, so connecting again resumes without duplicates.
export const INJURY_MASTER_DISCONNECT_MUTATION = gql`
  mutation INJURY_MASTER_DISCONNECT_MUTATION($input: InjuryMasterDisconnectInput!) {
    injuryMasterDisconnect(input: $input) {
      ok
    }
  }
`

// Starts a run and returns at once; the progress is polled with INJURY_MASTER_SYNC_RUN_QUERY.
export const INJURY_MASTER_SYNC_MUTATION = gql`
  mutation INJURY_MASTER_SYNC_MUTATION {
    injuryMasterSync {
      id
      status
    }
  }
`

export const INJURY_MASTER_CLAIM_NUMBER_REFRESH_MUTATION = gql`
  mutation INJURY_MASTER_CLAIM_NUMBER_REFRESH_MUTATION($riskId: ID!, $fieldId: ID!) {
    injuryMasterClaimNumberRefresh(riskId: $riskId, fieldId: $fieldId) {
      ok
    }
  }
`
